import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';

@Injectable()
export class HttpInterceptorService implements HttpInterceptor {

  constructor(private router: Router) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          // Clear session and redirect to login
          localStorage.removeItem('sessionId');
          localStorage.removeItem('userId');
          localStorage.removeItem('username');
          localStorage.removeItem('roles');
          this.router.navigate(['/login']);
        }
        // rxjs 6: throwError takes the error itself. The rxjs 7 factory form
        // (() => error) would emit the arrow function as the error.
        return throwError(error);
      })
    );
  }
}
